import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import '../styles/Classes.css';
import Header from '../components/Header.jsx';
import Footer from '../components/Footer.jsx';
import { FaLanguage, FaClock, FaCalendar, FaMapMarkerAlt, FaDesktop } from 'react-icons/fa';

export default function Classes() {
    const location = useLocation();
    
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    return (
        <div className="classes-page">
            <Header />
            
            <main className="classes-main">
                <div className="classes-hero">
                    <div className="classes-badge">IELTS & TOEFL PREPARATION</div>
                    <h1>International English Proficiency Classes</h1>
                    <p className="classes-subtitle">Prepare for your international exams with expert guidance and achieve your target score.</p>
                </div>

                <div className="classes-content">
                    <div className="classes-info">
                        <h2>Class Details</h2>
                        
                        <div className="info-grid">
                            <div className="info-item">
                                <FaCalendar className="info-icon" />
                                <div className="info-text">
                                    <span className="info-label">Start Date</span>
                                    <span className="info-value">May 1st, 2026</span>
                                </div>
                            </div>
                            
                            <div className="info-item">
                                <FaClock className="info-icon" />
                                <div className="info-text">
                                    <span className="info-label">Time</span>
                                    <span className="info-value">6pm - 8pm</span>
                                </div>
                            </div>
                            
                            <div className="info-item">
                                <FaDesktop className="info-icon" />
                                <div className="info-text">
                                    <span className="info-label">Platform</span>
                                    <span className="info-value">Google Meet (Online)</span>
                                </div>
                            </div>
                            
                            <div className="info-item">
                                <FaCalendar className="info-icon" />
                                <div className="info-text">
                                    <span className="info-label">Duration</span>
                                    <span className="info-value">1 Month</span>
                                </div>
                            </div>
                        </div>

                        <div className="schedule-box">
                            <h3>Weekly Schedule</h3>
                            <p>4 days per week for 4 weeks</p>
                            <ul className="days-list">
                                <li>Monday</li>
                                <li>Tuesday</li>
                                <li>Wednesday</li>
                                <li>Thursday</li>
                            </ul>
                        </div>

                        <div className="features-box">
                            <h3>What's Included</h3>
                            <ul>
                                <li>Live interactive classes</li>
                                <li>Practice tests & quizzes</li>
                                <li>Study materials</li>
                                <li>Mock exams</li>
                                <li>Certificate of completion</li>
                                <li>One-on-one feedback sessions</li>
                            </ul>
                        </div>
                    </div>

                    <div className="classes-form">
                        <h2>Register Now</h2>
                        <p className="form-subtitle">Complete the form below to secure your spot</p>
                        
                        <div className="form-embed">
                            <iframe 
                                src="https://docs.google.com/forms/d/e/1FAIpQLScMSC4-XdJS53rv4O93OkR0xmIBmzEXbxZ1E8EBlnn8DVGjAQ/viewform?embedded=true" 
                                width="100%" 
                                height="600" 
                                frameBorder="0" 
                                marginHeight="0" 
                                marginWidth="0"
                                title="IELTS & TOEFL Registration Form"
                            >
                                Loading…
                            </iframe>
                        </div>
                        
                        <p className="form-note">
                            Having trouble? <a href="https://nw.ax/d6" target="_blank" rel="noreferrer">Click here to register directly</a>
                        </p>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
}